module.exports = new __parcel__URL__("tshirt_redlogo.3dcf4661.jpg").toString();